import React, { useState } from 'react'
import i18n from "../constants/i18n";
import { Form, Button, Row, Col } from "react-bootstrap";

function ContactForm(props) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [topic, setTopic] = useState('');
  const [contents, setContents] = useState('');
  const [sendCopy, setSendCopy] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [check, setCheck] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [serverError, setServerError] = useState(false)


  const cleaner = () => {
    const form = document.querySelectorAll('.form-control');
    form.forEach((e, index) => index === 3 ? e.value = 'Select Topic' : e.value = '');
    setFirstName('');
    setLastName('');
    setEmail('');
    setTopic('');
    setContents('');
    setSendCopy('');
  }


  const sendEmail = async (e) => {
    e.preventDefault();
    if (firstName.length !== 0 && lastName.length !== 0 && email.length !== 0 && topic.length !== 0 && contents.length !== 0) {
      setCheck(false);
      setClicked(true);
      setTimeout(() => {
        setClicked(false);
      }, 10000)

      fetch('https://gfsoft.pl:5000/sendmail', {

        method: 'post',

        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          firstName,
          lastName,
          email,
          topic,
          contents,
          sendCopy
        })


      })
        .then(res => {
          console.log(res.status)
          if (res.status === 200) {
            setError(false);
            setServerError(false);
            setSuccess(true);
            cleaner()
          }

          if (res.status !== 200) {
            setError(true);
            setServerError(false);
            setSuccess(false);
          }
        })
        .catch(error => {
          console.log("Error", error)
          setServerError(true);
          setError(false);
          setSuccess(false);
        })
    } else {
      setCheck(true);
    }

  }

  return (

    <Row
      style={{
        borderRadius: "0.5rem",
        border: "1px solid rgba(0,0,0,0.1)",
        boxShadow: "0px 30px 40px 0px rgba(0,0,0,0.12)",
        background: "white",
      }}
    >
      {/* <div >
                    
                </div> */}
      <Col xs={12}>
        <Row style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
          <Button variant="flat" className={'btn-flat'} onClick={props.closeClicked} ><b className={'btn-content-contactForm'}>x</b></Button>

        </Row>
        {check ? <p style={{ textAlign: 'center', color: 'red', fontWeight: 'bold' }} >{`${i18n.t("FillAllFields")}`}</p> : null}
        {error ? <p style={{ textAlign: 'center', color: 'red', fontWeight: 'bold' }} >{`${i18n.t("Error")}`}</p> : null}
        {success ? <p style={{ textAlign: 'center', color: 'green', fontWeight: 'bold' }} >{`${i18n.t("MessageSend")}`}</p> : null}
        {serverError ? <p style={{ textAlign: 'center', color: 'red', fontWeight: 'bold' }}>{`${i18n.t("ServerErrorEmail")}`}</p> : null}
        <Form
          style={{ margin: "1rem", marginTop: "2rem" }}
          onSubmit={sendEmail}
        >
          <Row>
            <Col xs={12}>

              <Form.Group controlId="formFirstName">
                <Form.Control
                  style={{ boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.1)" }}
                  type="text"
                  placeholder={`${i18n.t("FirstName")}`}
                  onChange={e => setFirstName(e.target.value)}
                />
              </Form.Group>

              <Form.Group controlId="formLastName">
                <Form.Control
                  style={{ boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.1)" }}
                  type="text"
                  placeholder={`${i18n.t("LastName")}`}
                  onChange={e => setLastName(e.target.value)}
                />
              </Form.Group>

              <Form.Group controlId="formBasicEmail">
                <Form.Control
                  style={{ boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.1)" }}
                  type="email"
                  placeholder={`${i18n.t("Email")}`}
                  onChange={e => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group controlId="formTopic">
                <Form.Control
                  style={{ boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.1)" }}
                  defaultValue={`${i18n.t("SelectTopic")}`}
                  as="select"
                  onChange={e => setTopic(e.target.value)}
                >
                  <option>{`${i18n.t("SelectTopic")}`}</option>
                  <option>{`${i18n.t("Technical")}`}</option>
                  <option>{`${i18n.t("General")}`}</option>
                  <option>{`${i18n.t("Business")}`}</option>
                </Form.Control>
              </Form.Group>

              <Form.Group controlId="contents">
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder={`${i18n.t("HowWeCanHelp")}`}
                  onChange={e => setContents(e.target.value)}
                />
              </Form.Group>

              <Button
                style={{ boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.2)" }}
                block
                variant="primary"
                type="submit"
                disabled={clicked}
              >
                {i18n.t("submit")}
              </Button>
            </Col>
          </Row>
          <Row
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}
            className="mt-3"
          >
            <Col xs={12} md={12} lg={6}>
              <Form.Group controlId="formBasicCheckbox">
                <Form.Check type="checkbox" label={`${i18n.t("SendCopy")}`} onChange={e => setSendCopy(e.target.value)} />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  )
}

export default ContactForm
